import React, { useEffect } from "react";
import Modal from "react-modal";
import "./Modal.css";
import useWalletContext from "../../hooks/useWalletContext";
import { ethers } from "ethers";
import { toast } from "react-toastify";

const customStyles = {
  overlay: {
    backgroundColor: "#1e1e1eee",
    zIndex: 999,
  },
  content: {
    backgroundColor: "#13151C",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    minWidth: 380,
    transform: "translate(-50%, -50%)",
    zIndex: 2,
    textAlign: "center",
    color: "white",
    border: "1px solid #7BF5FB",
    padding: "0.5em",
  },
};

const DepositModal = ({
  open,
  setOpen,
  balance,
  deposit,
  decimals,
  symbol,
}) => {
  const { signer } = useWalletContext();

  const [amount, setAmount] = React.useState("");
  const [useMax, setUseMax] = React.useState(false);
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    // reset state
    setAmount("");
    setUseMax(false);
    setError("");
    setLoading(false);
  }, [open]);

  const success = (msg) =>
    toast.success(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
    });

  const errorToast = (msg) =>
    toast.error(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
    });

  useEffect(() => {
    if (Number(amount) > Number(balance?.formatted)) {
      setError("Insufficient balance");
    } else {
      setError("");
    }
  }, [amount]);

  const handleDeposit = async () => {
    try {
      setLoading(true);
      let value = useMax
        ? balance?.value
        : ethers.utils.parseUnits(amount, decimals);

      const tr = await deposit(value, signer);

      success(`Deposit successful.`);
      setOpen(false);
    } catch (error) {
      errorToast(error.reason || error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={open}
      onRequestClose={() => {
        if (!loading) setOpen(false);
      }}
      style={customStyles}
      contentLabel="Connect Modal"
    >
      <h2
        style={{
          fontSize: "1.5em",
          padding: "0.5em",
          marginBottom: "0.5em",
        }}
      >
        Enter Amount to stake
      </h2>
      <div
        style={{
          display: "flex",
        }}
      >
        <input
          className={"modal-input"}
          style={{
            width: "100%",
            padding: "1em",
            paddingTop: "1em",
            fontSize: "1em",
            fontWeight: "bold",
            border: "none",
          }}
          type={"number"}
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          aria-errormessage={error}
        />
        <button
          style={{
            padding: "0.5em",
            fontSize: "1em",
            fontWeight: "bold",
            backgroundColor: "white",
            color: "black",
            border: "none",
            borderLeft: "1px solid black",
          }}
          disabled={loading}
          onClick={() => {
            setUseMax(useMax);
            setAmount(Number(balance?.formatted));
          }}
        >
          Max
        </button>
      </div>
      <div
        style={{
          textAlign: "left",
          marginTop: "0.3em",
        }}
      >
        <span>
          Available Balance: {balance?.formatted} {symbol}
        </span>
      </div>
      <div
        style={{
          minHeight: "2em",
          backgroundColor: error ? "#ff000077" : "transparent",
          padding: "0.35em",
          fontWeight: "bold",
        }}
      >
        <span>{error}</span>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "1em",
          gap: "1em",
        }}
      >
        <button
          className={"btn"}
          disabled={loading}
          onClick={() => {
            setOpen(false);
          }}
        >
          Cancel
        </button>
        <button
          className={"btn"}
          disabled={
            loading || error || Number(amount) === 0 || isNaN(Number(amount))
          }
          onClick={handleDeposit}
        >
          Stake
        </button>
      </div>
    </Modal>
  );
};

export default DepositModal;
